import { useEffect } from 'react';

// Подтипы реверса больше не поддерживаются - фильтр знает только «Реверсивный».
const LEGACY_REVERSE_SUBTYPES = ['reverseOpened', 'reverseClosed'];

export const normalizeFactoringTypeFilter = (value: string) =>
  LEGACY_REVERSE_SUBTYPES.includes(value) ? 'reverse' : value;

/**
 * Возвращает значение фильтра «Тип факторинга» без устаревших подтипов реверса
 * и сбрасывает такой подтип, если он сохранён в URL/состоянии фильтра.
 */
export const useFactoringTypeFilter = (
  value: string,
  onReset: (value: string) => void
) => {
  const normalized = normalizeFactoringTypeFilter(value);

  useEffect(() => {
    if (normalized !== value) onReset(normalized);
  }, [normalized, value, onReset]);

  return normalized;
};
